<div class="p-2">
  <!-- Title -->
  <div class="row pb-2">
    <div class="col-6 h5 text-muted p-0">Coupons</div>
    <div class="col-6 p-0">
      <span class="float-end">
        <button type="button" class="btn btn-outline-secondary btn-sm" title="Available National Coupons" (click)="showDemoNationalCoupons()">
          Available National Coupons
        </button>
      </span>
    </div>
  </div>

  <div class="row bg-light">
    <div class="col-12 p-2">

      <!-- Filters -->
      <div class="row bg-white m-0">
        <div class="col-12">
          <div class="row mt-2 mb-2">
            <div class="col-5">
              <select class="form-select text-muted" [(ngModel)]="selectedStore" (change)="onStoreChange($event)"
                [disabled]="couponsLoading === true">
                <option *ngFor="let store of stores" [value]="store.store_id">{{ store.store_name }}
                  ({{ store.store_coupon_count }})</option>
              </select>
            </div>
            <div class="col-1">
              <div class="spinner-grow spinner-grow-sm text-info" role="status" *ngIf="storesLoading === true"></div>
            </div>
            <div class="col-3 coupon_source_button_group">
              <div class="btn-group float-end">
                <label [class]="couponSource === 'retailer' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="retailer" tabindex="0" role="button" (click)="oncouponSourceChange('retailer')">Retailer</label>
                <!--<label [class]="couponSource === 'cpg' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="cpg" tabindex="0" role="button" (click)="oncouponSourceChange('cpg')">Regional</label>-->
                <label [class]="couponSource === 'national' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="national" tabindex="0" role="button" (click)="oncouponSourceChange('national')">National</label>
              </div>
            </div>

            <div class="col-3 coupon_status_button_group">
              <div class="btn-group float-end">
                <label [class]="couponStatus === 'expired' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="retailer" tabindex="0" role="button" (click)="oncouponStatusChange('expired')">Expired</label>
                <label [class]="couponStatus === 'active' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="cpg" tabindex="0" role="button" (click)="oncouponStatusChange('active')">Active</label>
                <label [class]="couponStatus === 'upcoming' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="national" tabindex="0" role="button" (click)="oncouponStatusChange('upcoming')">Upcoming</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Coupons -->
      <!-- Loading -->
      <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="couponsLoading === true">
        <div class="col-12">
          <div class="spinner-border text-info  mt-4" role="status"></div>
        </div>
      </div>

      <div class="row mt-2 pt-2 pb-4">
        <div class="col-12">
          <!-- Empty message -->
          <div class="row text-center mt-4 mb-4" *ngIf="storesLoading == false && couponsLoading == false && coupons.length == 0"> 
            <i-bs class="text-black-50 mt-4 pt-4" name="tags" width="30" height="30"></i-bs>
            <div class="col-12 mb-4 pb-4 text-black-50">Coupons not found</div>
          </div>

          <!-- Display coupon -->
          <div class="row" *ngIf="couponsCount > 0"> 
            <div class="col-2"> <!-- Display Type -->
              <span style="margin-left: 10px;">
                <i-bs [class]="displayType == 'grid' ? 'text-secondary' : 'text-black-50 cursor-pointer'" name="grid" width="20" height="20" title="Grid view" (click)="changeDisplayType('grid')"></i-bs>
                <i-bs [class]="displayType == 'list' ? 'text-secondary' : 'text-black-50 cursor-pointer'" style="margin-left: 10px;" name="list" width="20" height="40" title="List view" (click)="changeDisplayType('list')"></i-bs>
              </span>
            </div>
            <div class="col-3">
              <button type="button" class="btn btn-outline-secondary btn-sm border-0" title="View Coupon Products" (click)="showCouponProducts()" *ngIf="couponStatus === 'active' && couponsCount > 0">
                View Coupon Products
              </button>
            </div>
            <div class="col-7">
              <!-- Pagination Top -->
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)"></pagination-controls>
            </div>
          </div>

          <!-- Grid -->
          <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'grid'">
            <div class="col-12 col-md-4 mb-3" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
              <app-show-coupon [module]="loginData?.user_details.provider_type" [couponListData]="coupons" [couponData]="coupon" [couponStoreId]="selectedStore" [displayType]="displayType"  (couponReviewAction)="onCouponReviewAction($event)">
              </app-show-coupon>
            </div>
          </div>

          <!-- List -->
          <!-- Display show-coupon only for first row (For list view loop is inside component) -->
          <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'list'">
            <div class="col-12" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
              <app-show-coupon [module]="loginData?.user_details.provider_type" [couponListData]="coupons" [couponData]="coupons[0]" [couponStoreId]="selectedStore" [displayType]="displayType"  (couponReviewAction)="onCouponReviewAction($event)" *ngIf="i == 0">
              </app-show-coupon>
            </div>
          </div>

          <!-- Pagination Bottom -->
          <div class="row mt-2">
            <div class="col-12">
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
